// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"296":"privacy","717":"pricing","929":"terms"}[chunkId] + "." + {"296":"681cd5e5","717":"4c0eaa04","929":"28c69b63"}[chunkId] + ".js";
};